import { axiosFactory } from './axiosFactory'

export const axiosMasStack = axiosFactory.resetDefaultHeaders(
  axiosFactory.getAxios('MasStack')
)
